import { render, staticRenderFns } from "./service-item-cascader.vue?vue&type=template&id=134e777a&scoped=true&"
import script from "./service-item-cascader.vue?vue&type=script&lang=js&"
export * from "./service-item-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134e777a",
  null
  
)

export default component.exports